export default __webpack_public_path__ + "static/media/q-logo.2baa5f89.svg";